import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Container, Row, Badge, Card, ListGroup, Button, Modal } from 'react-bootstrap';
import {fetchAssignmentsForThisBook, fetchOneBook, updateBook} from '../../http/bookAPI';
import {
    FaBook,
    FaTag,
    FaEdit,
    FaPlusCircle,
    FaUserTie,
    FaChartBar,
    FaStar,
    FaCalendar,
    FaGlobe,
    FaInfoCircle,
    FaTrashAlt,
    FaArrowCircleUp,
    FaArrowCircleDown,
    FaArrowUp, FaArrowDown, FaCat, FaTags, FaQuestionCircle
} from 'react-icons/fa';
import { Context } from "../../index";
import CreateAssign from "../modals/assign/CreateAssign";
import EditBook from "../modals/book/EditBook";
import { observer } from "mobx-react-lite";
import AssignUnderBookS3 from "./AssignUnderBookS3";
import AssignUnderBookS2 from "./AssignUnderBookS2";
import AssignUnderBookS1 from "./AssignUnderBookS1";
import AssignUnderBookS4 from "./AssignUnderBookS4";
import Loader from "../Loader";
import {toast} from "react-toastify";
import {getRedirectUrlApi} from "../../http/userAPI";
import CacheUpdateGreenLine from "../../helpers/CacheUpdateGreenLine";
import SimpleLogsViewerBA from "../logs/SimpleLogsViewerBA";
import {useNavigate} from "react-router-dom";
import {PAY_ROUTE} from "../../utils/consts";
import DownloadProgressModal from "../modals/DownloadProgressModal";
import {downloadWithProgress} from "../../helpers/downloadWithProgress";
import BookAlwaysOnTop from "../modals/book/BookAlwaysOnTop";


const BookFull = observer(({ bookobject, setActiveComponent, compMode }) => {

    const [hoveredItemId, setHoveredItemId] = useState(null);
    const { user } = useContext(Context);

    const [editbookVisible, setEditBookVisible] = useState(false);
    const [thisBook, setThisBook] = useState({});
    const [assignmentsforthisbook, setAssignmentsForThisBook] = useState([]); // Массив для заданий книги
    const [loading, setLoading] = useState(false);
    const [addAssignVisible, setAddAssignVisible] = useState(false);
    const { book } = useContext(Context);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [inputValueDelete, setInputValueDelete] = useState("");
    const [downloadModal, setDownloadModal] = useState({ show: false, progress: 0, status: "" });
    const [bookAlwaysOnTopVisible, setBookAlwaysOnTopVisible] = useState(false);
    const [onTopNoticeVisible, setOnTopNoticeVisible] = useState(false);
    const userId = user?.user?.id;
    const [assignmentMode, setAssignmentMode] = useState('book')
    const navigate = useNavigate();

    const MARKETPLACE_OPTIONS = [
        { code: 'com', label: 'Amazon.com (US)' },
        { code: 'co.uk', label: 'Amazon.co.uk (UK)' },
        { code: 'ca', label: 'Amazon.ca (CA)' },
        { code: 'de', label: 'Amazon.de (DE)' },
        { code: 'fr', label: 'Amazon.fr (FR)' },
        { code: 'it', label: 'Amazon.it (IT)' },
        { code: 'es', label: 'Amazon.es (ES)' },
        { code: 'co.jp', label: 'Amazon.co.jp (JP)' },
        { code: 'com.au', label: 'Amazon.com.au (AU)' },
        { code: 'in', label: 'Amazon.in (IN)' },
        { code: 'com.mx', label: 'Amazon.com.mx (MX)' },
        { code: 'com.br', label: 'Amazon.com.br (BR)' },
    ];

    const getFirstAvailableAmazonAsin = () => (
        bookobject?.kindle_asin ||
        bookobject?.paper_back_asin ||
        bookobject?.hard_cover_asin ||
        bookobject?.audio_asin ||
        bookobject?.audio_audible_asin ||
        ''
    ).trim().toUpperCase();

    const openMarketplaceAmazonLink = async (marketplaceCode, event) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();

        const asin = getFirstAvailableAmazonAsin();
        if (!/^[A-Z0-9]{10}$/.test(asin)) {
            toast.info("No ASIN is available for this book.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            const response = await getRedirectUrlApi(`https://www.amazon.${marketplaceCode}/dp/${asin}`);
            if (response?.redirectUrl) {
                window.open(response.redirectUrl, "_blank", "noopener noreferrer");
            }
        } catch (error) {
            toast.error("Failed to open Amazon marketplace.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
        }
    };

    const renderMarketplaceLink = (code, text = `.${code}`) => {
        const marketplace = MARKETPLACE_OPTIONS.find((m) => m.code === code);
        if (!marketplace) return text;

        return (
            <button
                type="button"
                className="btn btn-link btn-sm p-0 align-baseline text-decoration-none"
                onClick={(event) => openMarketplaceAmazonLink(code, event)}
            >
                {text}
            </button>
        );
    };
    const isOutsideTariffLimit = bookobject?.assignment_creation_locked === true;
    const tariffBookLimit = bookobject?.tariff_book_limit || 1;
    const tariffLockTooltip = `Upgrade your plan to create assignments for books/products outside your newest ${tariffBookLimit} item${tariffBookLimit === 1 ? '' : 's'}.`;

    const date = new Date(bookobject?.createdAt) ;
    // Массив с сокращениями месяцев
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hasManuscriptFile = Boolean(
        bookobject?.book_download &&
        bookobject.book_download !== "NO_MANUSCRIPT"
    );
    const formatManuscriptSize = (bytes) => {
        const value = Number(bytes);
        if (!Number.isFinite(value) || value <= 0) return "";
        if (value >= 1024 * 1024) return `${(value / 1024 / 1024).toFixed(2)} MB`;
        if (value >= 1024) return `${(value / 1024).toFixed(1)} KB`;
        return `${value} B`;
    };
    const manuscriptSizeBytes =
        bookobject?.book_file_display_size_bytes ||
        bookobject?.book_file_processed_size_bytes ||
        bookobject?.book_file_size_bytes ||
        bookobject?.book_file_original_size_bytes;
    const manuscriptSizeLabel = hasManuscriptFile
        ? (formatManuscriptSize(manuscriptSizeBytes) || "PDF")
        : "";
    const isMobile = window.innerWidth < 480; // или useMediaQuery

    const bookRatingInfo = book?.getBookRatingInfo(bookobject.id);
    const currentBook = thisBook?.id ? thisBook : bookobject;
    const isCurrentBookLive = currentBook?.status === "LIVE";
    const isCurrentBookOnTopActive = Number(currentBook?.always_on_top_until || 0) > Date.now();
    const currentItemLabel = currentBook?.book_type === "product" ? "Product" : "Book";
    const activeAssignmentOnTop = assignmentsforthisbook.find((assignment) =>
        assignment?.assignment_status === "NEW" &&
        assignment?.reviewer_reading_step === "NO_STEP" &&
        Number(assignment?.always_on_top_until || 0) > Date.now()
    );

    const handleBookDataUpdate = async (bookId) => {
        try {
            const data = await fetchAssignmentsForThisBook(bookobject.id); // Запрос к API
            setAssignmentsForThisBook(data); // Обновляем состояние со списком заданий
        } catch (error) {
            console.error('Error fetching assignments:', error);
        }
    };

    useEffect(() => {
        if (!book?.selectedCurrentUserBook?.id) return; // ✅ Проверяем, существует ли ID книги

        const loadAssignments = async () => {

            try {
                const data = await fetchAssignmentsForThisBook(book.selectedCurrentUserBook.id);
                setAssignmentsForThisBook(data);
            } catch (error) {
                console.error("Error loading assignments:", error);
            } finally {

            }
        };

        loadAssignments();
    }, [book?.selectedCurrentUserBook?.id, assignmentsforthisbook.length]);


    const handleBookUpdate = async () => {
        try {
            const updatedBook = await fetchOneBook(bookobject?.id); // Функция получения обновленных данных книги
            setThisBook(updatedBook); // Обновляем состояние книги
            book.setSelectedCurrentUserBook(updatedBook); // Обновляем выбранную книгу
        } catch (error) {
            console.error("Failed to update book data:", error);
        }
    };

    const handleManuscriptDownload = async () => {
        if (!bookobject?.id) return;
        setDownloadModal({
            show: true,
            progress: 0,
            status: "Preparing secure manuscript download...",
        });
        try {
            await downloadWithProgress({
                path: `api/book/${bookobject.id}/manuscript-download`,
                filename: `${bookobject?.title || "virtalibry-manuscript"}.pdf`,
                onProgress: (progress) => setDownloadModal((prev) => ({ ...prev, progress })),
                onStatus: (status) => setDownloadModal((prev) => ({ ...prev, status })),
            });
            setTimeout(() => {
                setDownloadModal((prev) => ({ ...prev, show: false }));
            }, 700);
        } catch (error) {
            console.error("Manuscript download failed:", error);
            setDownloadModal((prev) => ({ ...prev, status: "Download failed. Please try again." }));
            toast.error("Failed to download manuscript. Please try again.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setTimeout(() => setDownloadModal((prev) => ({ ...prev, show: false })), 1400);
        }
    };

    useEffect(() => {
        if (!book?.selectedCurrentUserBook?.id) return;
        handleBookUpdate();
    }, [book?.selectedCurrentUserBook?.description_full]);

    const deleteBook = async () => {
      try {
          const formData = new FormData();
          formData.append('status', 'DELETED');
          formData.append('userId', userId);
          await updateBook(bookobject.id, formData);

          toast.success("Book Deleted Successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
          await handleBookUpdate();
      }
        catch (error) {
            console.error("Failed to delete book:", error);
        }
    };

    const successCount = assignmentsforthisbook.filter(
        assignment => assignment.assignment_status === 'SUCCESS'
    ).length;
    const searchingCount = assignmentsforthisbook.filter(
        assignment => assignment.assignment_status === 'NEW'
    ).length;
    const ongoingStatuses = [
        'READING',
        'READING_RIDT',
        'READING_RE',
        'REPORTED',
        'REPORTED_RFU',
        'REPORTED_RV'
    ];

    const ongoingCount = assignmentsforthisbook.filter(
        assignment => ongoingStatuses.includes(assignment.assignment_status)
    ).length;

    // helper (положи рядом с компонентом)

    const bookFromStore  = book?.selectedCurrentUserBook;

    const fmtUSD = (n) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);

    const priceSuffix = (v) => {
        const n = Number(v);
        return Number.isFinite(n) && n > 0 ? ` (${fmtUSD(n)})` : '';
    };

    // helpers (положи рядом с компонентом)
    const toDate = (v) => {
        if (v == null) return null;
        const n = Number(v);
        if (Number.isFinite(n)) {
            const ms = n > 1e12 ? n : n * 1000; // ms или sec
            return new Date(ms);
        }
        const parsed = Date.parse(v);
        return Number.isNaN(parsed) ? null : new Date(parsed);
    };

    const humanizeRelative = (inp) => {
        const d = inp instanceof Date ? inp : toDate(inp);
        if (!d) return '';
        const now = new Date();
        let diff = now.getTime() - d.getTime(); // >0 => ago
        const tense = diff >= 0 ? 'Ago' : 'From Now';
        diff = Math.abs(diff);

        const sec = Math.floor(diff / 1000);
        let n, unit;
        if (sec < 60) { n = sec; unit = 'Second'; }
        else if (sec < 3600) { n = Math.floor(sec / 60); unit = 'Minute'; }
        else if (sec < 86400) { n = Math.floor(sec / 3600); unit = 'Hour'; }
        else { n = Math.floor(sec / 86400); unit = 'Day'; }

        if (n === 0) return 'Just Now';
        return `${n} ${unit}${n !== 1 ? 's' : ''} ${tense}`;
    };

    const formatTime = (v) => {
        const d = toDate(v);
        if (!d) return '—';
        const dateStr = d.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'long', year: 'numeric', timeZone: 'Europe/Kyiv'
        });
        const timeStr = d.toLocaleTimeString('en-GB', {
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false, timeZone: 'Europe/Kyiv'
        });
        const rel = humanizeRelative(d);
        return `${dateStr} ${timeStr}${rel ? ` (${rel})` : ''}`;
    };


    return (
        <Card className="p-3 w-100 mt-2">
            <DownloadProgressModal
                show={downloadModal.show}
                progress={downloadModal.progress}
                status={downloadModal.status}
            />


            {loading ? (
                <Loader />
            ) : (
                <>

                    {book?.selectedCurrentUserBook.status === "DELETED" ? ( <>
                        <Card className="p-1 w-100 mt-1">
                            <div className="container mt-2">
                                <h6 className="text-muted">
                                    This book/product has been marked as deleted and is scheduled for permanent removal.
                                </h6>
                                <p className="text-muted small">
                                    You requested to remove this book/product from your library/store. The cover and manuscript have already been erased from our servers. However, before we permanently delete the database record, we will carefully check if the book/product has any existing links — for example, created assignments or related activities.
                                    <br />
                                    If no connections are found, the system will fully remove the book/product record in a few minutes, completing the deletion process. But if any links are detected, the record will be preserved to maintain the integrity of the system, even though the book’s/product's content itself is permanently gone. Please note: recovery is not possible. To bring this book/product back, you would need to add it again as a new entry.
                                </p>
                            </div>

                        </Card>
                    </>) : (
                        <>
                            <Card className="d-flex w-100 position-relative">
                                {isCurrentBookOnTopActive && (
                                    <span
                                        className="badge bg-success text-uppercase position-absolute shadow-sm"
                                        style={{
                                            top: "10px",
                                            right: "12px",
                                            zIndex: 2,
                                            fontSize: "0.68rem",
                                        }}
                                    >
                                        {currentItemLabel} on top
                                    </span>
                                )}
                                <Card.Body style={{ paddingTop: isCurrentBookOnTopActive ? "2rem" : undefined }}>
                                    <Row className="g-3">
                                        {/* Левая колонка: изображение */}
                                        <Col xs={12} md={2} className="d-flex justify-content-center align-items-start">
                                            <div className="d-flex flex-column align-items-center w-100">
                                                <Image
                                                    src={
                                                        bookobject.cover_file
                                                            ? `${process.env.REACT_APP_API_URL}covers/${bookobject.cover_file}`
                                                            : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                                    }
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '160px',

                                                        objectFit: 'cover',
                                                        borderRadius: '8px'
                                                    }}
                                                    className="shadow mb-0 mx-auto d-block"
                                                    alt="Book Cover"
                                                />
                                                <Button
                                                    variant={isCurrentBookOnTopActive ? "success" : "outline-success"}
                                                    size="sm"
                                                    className="mt-2 shadow-sm fw-semibold"
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "160px",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "0.78rem",
                                                    }}
                                                    onClick={() => setBookAlwaysOnTopVisible(true)}
                                                    disabled={!isCurrentBookLive}
                                                    title={isCurrentBookLive ? undefined : "Always on Top is available only for LIVE books/products."}
                                                >
                                                    <FaArrowUp className="me-1" />
                                                    {isCurrentBookOnTopActive ? `${currentItemLabel} on top` : "Always on top"}
                                                </Button>
                                            </div>
                                        </Col>

                                        {/* Заголовок на две колонки: инфо + кнопки */}
                                        {/* Инфо + заголовок */}
                                        <Col xs={12} md={10}>
                                            <Card.Title className="mb-2">
                                                <p className="d-flex justify-content-between align-items-center fs-4 lh-sm fw-medium text-muted mb-0 ms-2">
                                                    <span className="fs-5">{bookobject?.title || 'No title available'}</span>
                                                    <span className="d-inline-flex align-items-center gap-2">
                                                        <span className="fs-6 text-body-secondary">#{bookobject?.id}</span>
                                                    </span>
                                                </p>
                                                {bookobject?.book_type === 'product' ? (
                                                    <>
                                                        <p className="fs-6 lh-sm fw-normal text-muted mb-0 p-0 ms-2 fst-italic">
                                                            Manufacturer: {bookobject.subtitle || 'No available'}
                                                        </p>
                                                        <p
                                                            className="small text-muted mt-1 ms-2 mb-1 d-flex flex-wrap justify-content-between align-items-center"
                                                            style={{ fontSize: '14px' }}
                                                        >
                                                <span className="me-2 text-truncate" style={{ maxWidth: '60%' }}>
                                                 Sold by: {bookobject?.author || 'No available'}
                                                </span>


                                                            {bookobject?.last_update_book_data_from_amazon_date && (<>
                                                         <span className="d-inline-flex align-items-center small gap-1">
                                                         <span className="fw-semibold text-success">Product Price Update:</span>
                                                          <span className="fw-semibold text-muted">
                                                            {formatTime(bookobject?.last_update_book_data_from_amazon_date)}
                                                          </span>
                                                        </span>
                                                            </>  )}
                                                        </p>
                                                    </>) : (
                                                        <>
                                                            <p className="fs-6 lh-sm fw-normal text-muted mb-0 p-0 ms-2 fst-italic">
                                                                {bookobject.subtitle || 'No available'}
                                                            </p>
                                                            <p
                                                                className="small text-muted mt-1 ms-2 mb-1 d-flex flex-wrap justify-content-between align-items-center"
                                                                style={{ fontSize: '14px' }}
                                                            >
                                                <span className="me-2 text-truncate" style={{ maxWidth: '60%' }}>
                                                 {bookobject?.author || 'No available'}
                                                </span>


                                                                {bookobject?.last_update_book_data_from_amazon_date && (<>
                                                         <span className="d-inline-flex align-items-center small gap-1">
    <span className="fw-semibold text-success">Book Price Update:</span>
    <span className="fw-semibold text-muted">
      {formatTime(bookobject?.last_update_book_data_from_amazon_date)}
    </span>
  </span>
                                                                </>  )}
                                                            </p>
                                                        </>
                                                )}

                                            </Card.Title>

                                        {/* Основной контент: инфо + кнопки */}
                                            <Row className="g-3">
                                                <Col xs={12} md={10} className="small">
                                                    <Row className="g-2">
                                                <Col xs={12} md={7} className="small">
                                                    <ListGroup variant="success">
                                                        <ListGroup.Item className="py-1 px-2">
                                                            <p className="mb-0 fst-italic text-muted">
                                                                <FaCalendar className="me-2 mb-1 text-success" />
                                                                Added: <strong>{`${day}-${month}-${year}`}</strong>,
                                                                {hasManuscriptFile ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link btn-sm p-0 ms-0 align-baseline text-success text-decoration-none"
                                                                        onClick={handleManuscriptDownload}
                                                                        title="Download your stored manuscript"
                                                                    >
                                                                            <span className="ms-2 fst-italic small text-muted">
                                                                        Download manuscript: <strong className="text-primary">{manuscriptSizeLabel}</strong>
                                                                            </span>
                                                                    </button>
                                                                ) : (
                                                                    <span className="ms-2 fst-italic text-muted">
                                                                        Manuscript: <strong>No Manuscript</strong>
                                                                    </span>
                                                                )}
                                                            </p>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item className="py-1 px-2">
                                                            <p className="mb-0 fst-italic text-muted">
                                                                <FaInfoCircle className="me-1 mb-1 text-success" />
                                                                {bookobject?.book_type === "product" ? "" : " Formats: "}
                                                                {bookobject.kindle_flag && bookobject.kindle_asin && (<>
                                                                    <span
                                                                        className="text-primary fw-semibold"
                                                                        role="button"
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = user?.user?.amz_country
                                                                                    ? `${user.user.amz_country}/dp/${bookobject.kindle_asin}`
                                                                                    : `https://www.amazon.com/dp/${bookobject.kindle_asin}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}
                                                                    > {bookobject?.book_type === "product" ? "Type 1" : "Kindle"}</span>{priceSuffix(bookFromStore?.kindle_price_on_amazon)}</>
                                                                )}
                                                                {bookobject.paper_back_flag && bookobject.paper_back_asin && (<>
                                                                    <span
                                                                        className="text-primary fw-semibold"
                                                                        role="button"
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = user?.user?.amz_country
                                                                                    ? `${user.user.amz_country}/dp/${bookobject.paper_back_asin}`
                                                                                    : `https://www.amazon.com/dp/${bookobject.paper_back_asin}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}
                                                                    > {bookobject?.book_type === "product" ? "Type 2" : "Paperback"}</span>{priceSuffix(bookFromStore?.paper_back_price_on_amazon)}</>
                                                                )}
                                                                {bookobject.hard_cover_flag && bookobject.hard_cover_asin && (<>
                                                                    <span
                                                                        className="text-primary fw-semibold"
                                                                        role="button"
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = user?.user?.amz_country
                                                                                    ? `${user.user.amz_country}/dp/${bookobject.hard_cover_asin}`
                                                                                    : `https://www.amazon.com/dp/${bookobject.hard_cover_asin}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}

                                                                    > {bookobject?.book_type === "product" ? "Type 3" : "Hardcover"}</span>{priceSuffix(bookFromStore?.hard_cover_price_on_amazon)}</>
                                                                )}
                                                                {bookobject.audio_flag && bookobject.audio_asin && (<>
                                                                    <span
                                                                        className="text-primary fw-semibold"
                                                                        role="button"
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = `https://www.amazon.com/dp/${bookobject.audio_asin}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}
                                                                    > {bookobject?.book_type === "product" ? "Type 4" : "Audiobook"} </span>{priceSuffix(bookFromStore?.fourth_price_on_amazon)}</>
                                                                )}
                                                            </p>
                                                        </ListGroup.Item>

                                                        <ListGroup.Item className="py-1 px-2">
                                                            <p className="mb-0 fst-italic text-muted">
                                                                <FaChartBar className="me-2 mb-1 text-success" />
                                                                Orders: <strong>{(searchingCount + ongoingCount + successCount) || 0}</strong>,
                                                                {searchingCount > 0 && (<> Searching: <strong>{searchingCount}</strong>,</>)}
                                                                {ongoingCount > 0 && (<> Working: <strong>{ongoingCount}</strong>,</>)}
                                                                {successCount > 0 && (<> Done: <strong>{successCount}</strong>.</>)}


                                                            </p>
                                                        </ListGroup.Item>

                                                    </ListGroup>
                                                </Col>
                                                <Col xs={12} md={5} className="small">
                                                    <ListGroup variant="success">
                                                        <ListGroup.Item className="py-1 px-2">
                                                            <p className="mb-0 fst-italic text-muted">
                                                                <FaGlobe className="me-2 mb-1 text-success" />
                                                                Language: <strong>{bookobject.language || 'No language available'}</strong>
                                                            </p>
                                                        </ListGroup.Item>
                                                        {(bookobject.kindle_unlimited_flag || bookobject.audio_exclusive_flag || bookobject.audio_non_exclusive_flag) &&
                                                            bookobject?.book_type !== "product" && (
                                                            <ListGroup.Item className="py-1 px-2">
                                                                <p className="mb-0 fst-italic text-muted">
                                                                    <FaTag className="me-2 mb-1 text-success" />
                                                                    Options: {bookobject.kindle_unlimited_flag && <strong>Kindle Unlimited, </strong>}
                                                                    {bookobject.audio_exclusive_flag && <strong>Audible Exclusive, </strong>}
                                                                    {bookobject.audio_non_exclusive_flag && <strong>Non-Exclusive</strong>}
                                                                </p>
                                                            </ListGroup.Item>
                                                        )}
                                                        {bookobject?.book_type === "product" && (
                                                                <ListGroup.Item className="py-1 px-2">
                                                                    <p className="mb-0 fst-italic text-muted">
                                                                        <FaTags className="me-2 mb-1 text-success" />
                                                                        Category: {book.genres
                                                                        ?.find((g) => g.id === bookobject?.booksGenreId)
                                                                        ?.genre || "—"}
                                                                    </p>
                                                                </ListGroup.Item>
                                                            )}

                                                        <ListGroup.Item className="py-1 px-2">
                                                            <p className="mb-0 fst-italic text-muted">
                                                                <FaStar className="me-2 mb-1 text-success" />
                                                                Rating:&nbsp;
                                                                {[...Array(5)].map((_, index) => (
                                                                    <i
                                                                        key={index}
                                                                        className={`bi ${
                                                                            index < Math.floor(bookRatingInfo?.successRating)
                                                                                ? "bi-star-fill"
                                                                                : index === Math.floor(bookRatingInfo?.successRating) &&
                                                                                bookRatingInfo?.successRating % 1 >= 0.3 &&
                                                                                bookRatingInfo?.successRating % 1 <= 0.7
                                                                                    ? "bi-star-half"
                                                                                    : "bi-star"
                                                                        }`}
                                                                        style={{
                                                                            color:
                                                                                index < Math.floor(bookRatingInfo?.successRating) ||
                                                                                (index === Math.floor(bookRatingInfo?.successRating) &&
                                                                                    bookRatingInfo?.successRating % 1 >= 0.3 &&
                                                                                    bookRatingInfo?.successRating % 1 <= 0.7)
                                                                                    ? "gold"
                                                                                    : "lightgray",
                                                                            fontSize: "12px",
                                                                            marginRight: "4px",
                                                                        }}
                                                                    ></i>
                                                                ))} {bookRatingInfo?.successRating > 0 && bookRatingInfo?.successRating}
                                                            </p>
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </Col>
                                                        <Col xs={12} md={12}>
                                                        <ListGroup variant="success" className="small mt-0">
                                                            <ListGroup.Item className="py-1 px-2">
                                                                <p className="mb-0 fst-italic text-muted">
                                                                    <FaInfoCircle className="me-2 mb-1 text-success" />
                                                                    Status: {bookobject.status === 'NEW' && (
                                                                    <>
                                                                        <span className="badge bg-success bg-opacity-75 text-uppercase me-2">On Moderation</span>
                                                                        <span>Will Live soon! Usually it takes 3–4 hours.</span>
                                                                    </>
                                                                )}
                                                                    {bookobject.status === 'LIVE' && (
                                                                        <>
                                                                            <span className="badge bg-success text-uppercase me-2">Live</span>
                                                                            <span>{!isMobile && 'Book/Product has been approved and is now eligible for review assignments.'}</span>
                                                                        </>
                                                                    )}
                                                                    {bookobject.status === 'NEEDFIX' && (
                                                                        <>
                                                                            <span className="badge bg-danger text-uppercase me-2">Correction Needed</span>
                                                                            <span>Changes are required before the book/product can be approved.</span>
                                                                        </>
                                                                    )}
                                                                </p>
                                                            </ListGroup.Item>

                                                            {bookobject.status === 'LIVE' && (
                                                                <ListGroup.Item className="py-1 px-2">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link btn-sm p-0 text-muted fst-italic text-decoration-none d-inline-flex align-items-center"
                                                                        onClick={() => setOnTopNoticeVisible(true)}
                                                                    >
                                                                        <FaQuestionCircle className="me-2 text-success" />
                                                                        About Always on Top feature: <span className="ms-1 text-success fw-semibold">Read full guide</span>
                                                                    </button>
                                                                </ListGroup.Item>
                                                            )}

                                                            {bookobject.message_flag && bookobject.status === 'NEEDFIX' && (
                                                                <ListGroup.Item className="py-1 px-1">
                                                                    <div
                                                                        className="alert alert-danger d-flex align-items-start py-1 px-1 mb-0"
                                                                        role="alert"
                                                                        style={{ borderRadius: "6px" }}
                                                                    >
                                                                        <FaUserTie
                                                                            className="me-2 flex-shrink-0 text-danger"
                                                                            style={{ marginTop: "2px" }} // ← ровно 6px вниз
                                                                        />
                                                                        <div className="lh-base">
                                                                            <strong className="text-danger">Message: </strong>
                                                                            <span className="text-dark">
            {bookobject.message || 'No message available'}
        </span>
                                                                        </div>
                                                                    </div>

                                                                </ListGroup.Item>
                                                            )}
                                                            <ListGroup.Item className="py-1 px-2">
                                                                <p className="mb-0 fst-italic text-muted">
                                                                    <FaInfoCircle className="me-2 mb-1 text-success" />
                                                                    Availability:{" "}
                                                                    {bookobject.territories_mode === "WORLDWIDE" && (
                                                                        <>
                                                                            <span className="badge bg-success me-2 py-1">
          WORLDWIDE
        </span>
                                                                            Available on all Amazon marketplaces worldwide.
                                                                        </>
                                                                    )}

                                                                    {bookobject.territories_mode === "MARKETPLACES" && (
                                                                        <>
        <span className="badge bg-secondary bg-opacity-75 me-2">
          LIMITED
        </span>
                                                                            Available on:&nbsp;
                                                                            <span className="text-dark">
          {(bookobject.available_marketplaces || []).map((mp, index) => (
              <React.Fragment key={mp}>
                  {index > 0 ? ", " : ""}
                  {renderMarketplaceLink(mp)}
              </React.Fragment>
          ))}
        </span>
                                                                        </>
                                                                    )}
                                                                </p>
                                                            </ListGroup.Item>
                                                        </ListGroup>
                                                    </Col>


                                                    </Row>
                                                </Col>
                                                {/* Кнопки */}

                                                <Col xs={12} md={2} className="d-flex flex-column flex-md-column flex-row justify-content-center align-items-stretch gap-1 mt-2">


                                                    {/* Кнопка Edit Book (только на десктопе) */}

                                                    <div className="w-100" title="Edit book details and submit for moderation.">
                                                        <Button
                                                            variant="success"
                                                            className="shadow-sm mt-1 btn-sm position-relative w-100 fw-light"
                                                            style={{
                                                                transition: "transform 0.2s",
                                                                transform: hoveredItemId === 'editBook' ? "scale(1.05)" : "scale(1)",
                                                                paddingLeft: "1.2rem",
                                                            }}
                                                            onMouseEnter={() => setHoveredItemId('editBook')}
                                                            onMouseLeave={() => setHoveredItemId(null)}
                                                            onClick={() => user?.setActiveComponent("EditBookInDashboard")}
                                                            aria-label="Edit book details and submit for moderation"
                                                        >
                                                            <FaEdit
                                                                className="position-absolute"
                                                                style={{
                                                                    left: "0.55rem",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                }}
                                                            />
                                                            {bookobject?.book_type === "product" ? "Edit Product" : "Edit Book"}
                                                        </Button>
                                                    </div>




                                                    {/* Кнопка Delete Book + попап подтверждения */}
                                                    <div className="position-relative w-100">
                                                        {(() => {
                                                            const hasAssignments = (assignmentsforthisbook?.length ?? 0) > 0;

                                                            const dynamicTitle = hasAssignments
                                                                ? "Sorry, you cannot fully delete this book/product because it has active or completed assignments. You can remove it from your list and exclude it from your plan (the record will stay)."
                                                                : (bookobject?.book_type === "product" ? "Delete this product" : "Delete this book");

                                                            const buttonText = hasAssignments
                                                                ? (bookobject?.book_type === "product" ? "Hide Prod" : "Hide Book")
                                                                : (bookobject?.book_type === "product" ? "Delete Prod" : "Delete Book");


                                                            const handleClick = () => {
                                                                if (hasAssignments) {
                                                                    user?.setActiveComponent("BookPayDelete")
                                                                } else {
                                                                    setShowConfirmDelete(true);
                                                                }
                                                            };

                                                            return (
                                                                <div className="w-100" title={dynamicTitle}>
                                                                    <Button
                                                                        variant="secondary"
                                                                        className="shadow-sm btn-sm position-relative w-100 mt-0 fw-light"
                                                                        style={{
                                                                            transition: "transform 0.2s",
                                                                            transform: hoveredItemId === "delBook" ? "scale(1.05)" : "scale(1)",
                                                                            paddingLeft: "1.5rem",
                                                                            // теперь не блокируем pointerEvents — тултип работает, и кнопка активна в обоих режимах
                                                                        }}
                                                                        onMouseEnter={() => setHoveredItemId("delBook")}
                                                                        onMouseLeave={() => setHoveredItemId(null)}
                                                                        onClick={handleClick}
                                                                        aria-label={dynamicTitle}
                                                                    >
                                                                        <FaTrashAlt
                                                                            className="position-absolute"
                                                                            style={{ left: "0.55rem", top: "50%", transform: "translateY(-50%)" }}
                                                                        />
                                                                        {buttonText}
                                                                    </Button>
                                                                </div>
                                                            );
                                                        })()}

                                                        {/* Попап: полноценное удаление (как было) */}
                                                        {showConfirmDelete && (
                                                            <div
                                                                className="bg-white border rounded p-2 shadow position-absolute"
                                                                style={{
                                                                    top: isMobile ? "auto" : "-192px",
                                                                    bottom: isMobile ? "80px" : "auto",
                                                                    right: 0,
                                                                    width: "280px",
                                                                    zIndex: 100,
                                                                }}
                                                            >
                                                                <p className="small mb-2">
                                                                    This will permanently delete this Record.<br />
                                                                    If no links exist, the entire record will be erased forever. <br />
                                                                    <strong>Type DELETE to confirm.</strong>
                                                                </p>

                                                                <input
                                                                    type="text"
                                                                    value={inputValueDelete}
                                                                    onChange={(e) => setInputValueDelete(e.target.value)}
                                                                    placeholder="Type DELETE"
                                                                    className="form-control mb-2"
                                                                />
                                                                <div className="d-flex justify-content-between">
                                                                    <button
                                                                        onClick={() => {
                                                                            if (inputValueDelete.trim().toUpperCase() === "DELETE") {
                                                                                deleteBook();
                                                                                setShowConfirmDelete(false);
                                                                                setInputValueDelete("");
                                                                            } else {
                                                                                toast.error("Please type 'DELETE' to confirm", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                                                            }
                                                                        }}
                                                                        className="btn btn-danger btn-sm flex-grow-1 me-1"
                                                                    >
                                                                        Confirm Delete
                                                                    </button>
                                                                    <button
                                                                        onClick={() => setShowConfirmDelete(false)}
                                                                        className="btn btn-outline-secondary btn-sm flex-grow-1 ms-1"
                                                                    >
                                                                        Close
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Кнопка Get Review — без изменений */}
                                                        {(() => {
                                                            const isStatusDisabled = bookobject.status === 'NEW' || bookobject.status === 'NEEDFIX';
                                                            const isDisabled = !isOutsideTariffLimit && isStatusDisabled;
                                                            const tooltip = isOutsideTariffLimit ? tariffLockTooltip : "Create an assignment to get a review";

                                                            return (
                                                                <div className="w-100" title={tooltip}>
                                                                    <Button
                                                                        variant="success"
                                                                        className="shadow-sm btn-sm position-relative w-100 mt-1 fw-light"
                                                                        style={{
                                                                            transition: "transform 0.2s",
                                                                            transform: hoveredItemId === 'getReview' ? "scale(1.05)" : "scale(1)",
                                                                            paddingLeft: "1.5rem",
                                                                            pointerEvents: isDisabled ? "none" : "auto",
                                                                        }}
                                                                        onMouseEnter={() => setHoveredItemId('getReview')}
                                                                        onMouseLeave={() => setHoveredItemId(null)}
                                                                        onClick={() => {
                                                                            if (isOutsideTariffLimit) {
                                                                                navigate(PAY_ROUTE);
                                                                                return;
                                                                            }
                                                                            setAssignmentMode('book');
                                                                            setAddAssignVisible(true);
                                                                        }}
                                                                        disabled={isDisabled}
                                                                        aria-disabled={isDisabled}
                                                                        aria-label={tooltip}
                                                                    >
                                                                        <FaPlusCircle
                                                                            className="position-absolute"
                                                                            style={{ left: "0.55rem", top: "50%", transform: "translateY(-50%)" }}
                                                                        />
                                                                        <strong>{isOutsideTariffLimit ? "Upgrade Plan" : "Get Review"}</strong>
                                                                    </Button>
                                                                </div>
                                                            );
                                                        })()}
                                                        {/* Кнопка Get Review — без изменений */}
                                                        {(() => {
                                                            const isStatusDisabled = bookobject.status === 'NEW' || bookobject.status === 'NEEDFIX';
                                                            const isDisabled = !isOutsideTariffLimit && isStatusDisabled;
                                                            const tooltip = isOutsideTariffLimit ? tariffLockTooltip : "Make Review Helpful or Write a Report (Only for Review in Success state)";

                                                            return (
                                                                <div className="w-100" title={tooltip}>
                                                                    <Button
                                                                        variant="outline-success"
                                                                        className="shadow-sm btn-sm position-relative w-100 mt-1 fw-light"
                                                                        style={{
                                                                            transition: "transform 0.2s",
                                                                            transform: hoveredItemId === 'makeHelpful' ? "scale(1.05)" : "scale(1)",
                                                                            paddingLeft: "1.5rem",
                                                                            pointerEvents: isDisabled ? "none" : "auto",
                                                                        }}
                                                                        onMouseEnter={() => setHoveredItemId('makeHelpful')}
                                                                        onMouseLeave={() => setHoveredItemId(null)}
                                                                        onClick={() => {
                                                                            if (isOutsideTariffLimit) {
                                                                                navigate(PAY_ROUTE);
                                                                                return;
                                                                            }
                                                                            setAssignmentMode('helpful');
                                                                            setAddAssignVisible(true);
                                                                        }}
                                                                        disabled={isDisabled}
                                                                        aria-disabled={isDisabled}
                                                                        aria-label={tooltip}
                                                                    >
                                                                        <FaArrowCircleUp
                                                                            className="position-absolute"
                                                                            style={{ left: "0.55rem", top: "50%", transform: "translateY(-50%)" }}
                                                                        />
                                                                        <strong>{isOutsideTariffLimit ? "Upgrade Plan" : "Tap Helpful"}</strong>

                                                                    </Button>
                                                                </div>
                                                            );
                                                        })()}
                                                    </div>


                                                </Col>



                                            </Row>
                                        </Col>


                                    </Row>
                                </Card.Body>
                            </Card>


                            {/* Блок для вывода заданий, относящихся к этой книге */}
                            <Card className="justify-content-start text-start start-0 mt-3 mb-1 p-2 small bg-white rounded">
                                <h6 className="fst-italic text-muted mt-1 mb-2">
                                    List of Assignments currently looking for a participant:
                                </h6>

                                {assignmentsforthisbook.some(
                                    assignment =>
                                        assignment.assignment_status === 'NEW' ||
                                        assignment.assignment_status === 'SUSPENDED'
                                ) ? (
                                    <Container fluid>
                                        <Row className="gx-2 gy-1">
                                            {assignmentsforthisbook
                                                .filter(
                                                    assignment =>
                                                        assignment.assignment_status === 'NEW' ||
                                                        assignment.assignment_status === 'SUSPENDED'
                                                )
                                                .map(assignment => (
                                                    <Col key={assignment.id} md={3} className="px-1 mx-auto mx-md-0">
                                                        <AssignUnderBookS1
                                                            assign={assignment}
                                                            isBookOnTopActive={isCurrentBookOnTopActive}
                                                            bookOnTopLabel={`${currentItemLabel} on top`}
                                                            activeAssignmentOnTopId={activeAssignmentOnTop?.id || null}
                                                            updateAssignments={() => {
                                                                fetchAssignmentsForThisBook(bookobject.id).then(setAssignmentsForThisBook);
                                                            }}
                                                        />
                                                    </Col>
                                                ))}
                                        </Row>
                                    </Container>
                                ) : (
                                    <p className="mt-0 mb-1 text-muted">
                                        You’re not looking for any participants right now. Use the <strong>Get Review</strong> button to start your next assignment.
                                    </p>
                                )}
                            </Card>

                            <Card className="justify-content-start text-start start-0 mt-1 mb-1 p-2 small bg-white rounded">
                                <h6 className="fst-italic text-muted mt-1 mb-2">
                                    List of assignments currently in progress:
                                </h6>

                                {assignmentsforthisbook.some(assignment =>
                                    ['READING', 'READING_RIDT', 'READING_RE'].includes(assignment.assignment_status)
                                ) ? (
                                    <Container fluid>
                                        <Row className="gx-2 gy-1">
                                            {assignmentsforthisbook
                                                .filter(assignment =>
                                                    ['READING', 'READING_RIDT', 'READING_RE'].includes(assignment.assignment_status)
                                                )
                                                .map(assignment => (
                                                    <Col key={assignment.id} md={3} className="px-1 mx-auto mx-md-0">
                                                        <AssignUnderBookS2 assign={assignment} />
                                                    </Col>
                                                ))}
                                        </Row>
                                    </Container>
                                ) : (
                                    <p className="mt-0 mb-1 text-muted">
                                        Now this list is empty. Use the <strong>Get Review</strong> button to start your next assignment.
                                    </p>
                                )}
                            </Card>

                            <Card className="justify-content-start text-start start-0 mt-1 mb-1 p-2 small bg-white rounded">
                                <h6 className="fst-italic text-muted mt-1 mb-2">
                                    List of assignments where the participant has reported completing a review:
                                </h6>

                                {assignmentsforthisbook.some(assignment =>
                                    ['REPORTED', 'REPORTED_RFU', 'REPORTED_RV', 'REPORTED_EXP'].includes(assignment.assignment_status)
                                ) ? (
                                    <Container fluid>
                                        <Row className="gx-2 gy-1">
                                            {assignmentsforthisbook
                                                .filter(assignment =>
                                                    ['REPORTED', 'REPORTED_RFU', 'REPORTED_RV', 'REPORTED_EXP'].includes(assignment.assignment_status)
                                                )
                                                .map(assignment => (
                                                    <Col key={assignment.id} md={4} className="px-1 mx-auto mx-md-0">
                                                        <AssignUnderBookS3 assign={assignment} />
                                                    </Col>
                                                ))}
                                        </Row>
                                    </Container>
                                ) : (
                                    <p className="mt-0 mb-1 text-muted">
                                        Now this list is empty. Use the <strong>Get Review</strong> button to start your next assignment.
                                    </p>
                                )}
                            </Card>

                            <Card className="justify-content-start text-start start-0 mt-1 mb-0 p-2 small bg-white rounded">
                                <h6 className="fst-italic text-muted mt-1 mb-2">
                                    List of confirmed assignments:
                                </h6>

                                {assignmentsforthisbook.some(assignment => assignment.assignment_status === 'SUCCESS') ? (
                                    <Container fluid>
                                        <Row className="gx-2 gy-1">
                                            {assignmentsforthisbook
                                                .filter(assignment => assignment.assignment_status === 'SUCCESS')
                                                .map(assignment => (
                                                    <Col key={assignment.id} md={4} className="px-1 mx-auto mx-md-0">
                                                        <AssignUnderBookS4 assign={assignment}
                                                                           updateAssignments={() =>
                                                                               fetchAssignmentsForThisBook(bookobject.id).then(setAssignmentsForThisBook)
                                                                           }
                                                        />
                                                    </Col>
                                                ))}
                                        </Row>
                                    </Container>
                                ) : (
                                    <p className="mt-0 mb-1 text-muted">
                                        Now this list is empty. Use the <strong>Get Review</strong> button to start your next assignment.
                                    </p>
                                )}
                            </Card>

                            <Card className="justify-content-start text-start start-0 mt-2 mb-0 p-0 bg-white rounded">
                                    <SimpleLogsViewerBA
                                        userId={user.user.id}
                                        type="book"   // или "book"
                                        targetId={book.selectedCurrentUserBook?.id}
                                        width="640px"
                                    />
                            </Card>






                            <CreateAssign
                show={addAssignVisible}
                handleClose={() => setAddAssignVisible(false)}
                bookData={bookobject}
                onBookDataUpdate={handleBookDataUpdate}  // Передаем callback для обновления данных
                mode={assignmentMode}
            />

            <EditBook
                show={editbookVisible}
                handleClose={() => setEditBookVisible(false)}
                bookData={bookobject}
                onUpdate={handleBookUpdate}
            />

            <Modal show={onTopNoticeVisible} onHide={() => setOnTopNoticeVisible(false)} top size="lg">
                <div className="modal-content">
                    <div className="modal-header small" style={{height: 40}}>
                        <h6 className="modal-title fs-6 mb-0">
                            <FaQuestionCircle className="me-2 text-success" style={{ transform: "translateY(-1px)" }} />
                            Always on Top
                        </h6>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setOnTopNoticeVisible(false)}
                        />
                    </div>
                    <div
                        className="modal-body small text-muted"
                        style={{
                            lineHeight: "1.48",
                            maxHeight: "70vh",
                            overflowY: "auto",
                            padding: "1rem 1.5rem",
                        }}
                    >
                        <p className="mb-2">
                            <strong>Book/Product Always on Top</strong> promotes the whole book/product.
                            If it has several open assignments, Virtalibry rotates them fairly inside that book/product by views and last library view time.
                        </p>
                        <p className="mb-2">
                            <strong>Assignment Always on Top</strong> promotes one specific open assignment.
                            Only one open assignment for the same book/product can be on top at a time.
                            While it is active, the other open assignments for that book/product are paused in the library/store rotation.
                        </p>
                        <p className="mb-2">
                            Paused assignments are not shown in the library/store until the active on-top assignment is taken by a reviewer or its paid time expires.
                            You cannot buy Assignment Always on Top for a paused assignment during that time.
                        </p>
                        <p className="mb-2">
                            Assignment Always on Top also cannot be purchased while the whole book/product already has Book/Product Always on Top active.
                            In that case, the book/product level promotion controls the rotation.
                        </p>
                        <p className="mb-2">
                            The library/store has up to <strong>8 Always on Top positions</strong> at the start of the results.
                            Book/Product on-top items go first, then assignment on-top items.
                        </p>
                        <p className="mb-2">
                            "On top" means placement at the top of the first results page.
                            Sorting by price does not move active Always on Top items below ordinary assignments.
                            Narrow filters still work normally: assignment type, book/product price, language, marketplace, country, and other filters can limit the visible pool.
                            If your offer matches the active filters, for example the reviewer filters for $0.99 books and your offer is a $0.99 book, it can appear in the top positions.
                        </p>
                        <p className="mb-2">
                            <strong>Please launch Always on Top thoughtfully.</strong>{" "}
                            Book/Product Always on Top cannot be canceled manually and the promotion fee is not refundable.
                            It ends automatically only when the paid time expires.
                        </p>
                        <p className="mb-2">
                            Assignment Always on Top is also not refundable.
                            You can still cancel the assignment itself, including an assignment with active Always on Top,
                            but the money spent on the promotion is not returned.
                        </p>
                        <p className="mb-0">
                            If more than 8 items want top placement, Virtalibry uses round-robin priority:
                            fewer views first, then older last view first.
                        </p>
                    </div>
                    <div
                        className="modal-footer small d-flex align-items-center justify-content-end px-2"
                        style={{height: 50, paddingTop: 0, paddingBottom: 0}}
                    >
                        <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => setOnTopNoticeVisible(false)}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Modal>

            <BookAlwaysOnTop
                show={bookAlwaysOnTopVisible}
                handleClose={() => setBookAlwaysOnTopVisible(false)}
                bookData={currentBook}
                assignments={assignmentsforthisbook}
                onPurchased={async (result) => {
                    if (result?.book) {
                        const mergedBook = {
                            ...currentBook,
                            ...result.book,
                        };
                        setThisBook(mergedBook);
                        book.setSelectedCurrentUserBook(mergedBook);
                    }
                    await handleBookUpdate();
                }}
            />
    </>
            )}
                </>
            )}

        </Card>

    );
});

export default BookFull;
